import * as React from 'react';
import { AppBar, useSidebarState } from 'react-admin';
import { Box, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Logo from '../assets/logo.png';

const CustomAppBar = () => {
    // Get the sidebar state and setter from useSidebarState
    const [open, setOpen] = useSidebarState();

    // Define a function to toggle the sidebar
    const toggleSidebar = () => {
        setOpen(!open);
    };

    return (
        <AppBar
            sx={{
                backgroundColor: 'white',
                color: 'black',
                left: open ? '240px' : '60px', // Adjust position based on sidebar state
                right: 0,
                width: 'auto',
                borderBottom: '1px solid #dcdfe4',
                borderRadius: 0,
                transition: 'left 0.3s',
                '& .RaAppBar-toolbar': {
                    padding: '20px',
                },
            }}
            elevation={1}
        >
            {/* Spacer to push content to the right */}
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }} />
        </AppBar>
    );
};

export default CustomAppBar;
